<template>
    <modal
        name="visibilidad-reducida-butaca"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
        id="visibilidad-reducida-butaca"
        :adaptive="true"
        :click-to-close="false"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2 class="text-dark">Butaca con visibilidad reducida</h2>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <h3 class="text-danger">Esta butaca es de visibilidad reducida, no garantizamos la perfecta visión del evento.</h3>
            </div>
            <div class="card-footer text-right">
                <slot name="footer">
                    <Button type="button" name="button" @click.prevent="aceptar()">Aceptar</Button>
                </slot>
            </div>
        </div>
    </modal>
</template>


<script>
    export default {
        methods: {
            aceptar(){
                this.$emit('aceptar');
            },
        },
    }
</script>